var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[(_vm.reasonCodeDescription)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.item.type)+" ")])]}}],null,false,1935606769)},[_c('span',[_vm._v(_vm._s(_vm.reasonCodeDescription))])]):_c('span',[_vm._v(" "+_vm._s(_vm.item.type)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }